import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { LoadError } from "../../components/catalogue/Notices";
import { PageWidth } from "../../components/catalogue/StoreShell";
import { useCustomerSession } from "../account/session";

/** Renders its children only for a signed-in customer; anyone else is sent to sign in and brought back. */
export function SignedInOnly({ children }: { children: ReactNode }) {
  const session = useCustomerSession();
  const { pathname } = useLocation();
  if (session.isPending) return <PageWidth className="py-10 type-body text-text-muted">Loading…</PageWidth>;
  if (!session.data) {
    return (
      <PageWidth className="py-10">
        <LoadError onRetry={() => session.refetch()} />
      </PageWidth>
    );
  }
  if (!session.data.user) return <Navigate to="/sign-in" replace state={{ from: pathname }} />;
  return children;
}
